<template>
  <div class="form-certification">
    <edit-table
      :option="option"
      :data="data"
      @submit-add="handleSubmit"
      @submit-edit="handleSubmit"
      @refresh-change="refreshChange"
      @rowDel="handleRowDel"
    />
  </div>
</template>

<script>
import EditTable from '@/components/editTable/index.vue';

export default {
  components: {
    EditTable,
  },
  data() {
    return {
      data: [
        {
          basicSalary: 'Activity Tracker',
          money: '5343',
        },
        {
          basicSalary: 'Activity Tracker',
          money: '8934',
        },
      ],
    }
  },
  computed: {
    option() {
      const option = {
        columns: [
          {
            label: this.i18n('basicSalary'),
            field: 'basicSalary',
            class: 'table-td',
            disabled: true,
          },
          {
            label: this.i18n('money'),
            field: 'money',
            class: 'table-td',
          },
        ],
      }
      return option
    },
  },
  methods: {
    // 国际化
    i18n(param) {
      return this.$t(`_staff.labelEmployment.${param}`)
    },
    handleSubmit(done, row) {
      console.log(row, 'handleSubmit');
      setTimeout(() => {
        done()
      }, 3000);
    },
    handleRowDel(done, row) {
      console.log(row, 'handleRowDel');
      setTimeout(() => {
        done()
      }, 3000);
    },
    refreshChange() {

    },
  },
}
</script>
<style lang="scss">
.form-certification{
  &-top{
    text-align: right;
  }
  .table-td{
    text-align: center;
    line-height: 50px;
    &-sm{
      width: 200px;
    }
  }
}
</style>
